import { jsx as _jsx } from "react/jsx-runtime";
import { FormattedDateTime, FormattedMessage, FormattedReactMessage } from 'LearningCenterUI/components/I18n';
import RetakeExamButton from './RetakeExamButton';
import { useFullTrack } from '../../tracks';
import { useExamExpiry, useMostRecentExamAttempt } from '../../exams';
import ExamFinishedScreenLayout from './ExamFinishedScreenLayout';

const ExamExpiredIncompleteExercisesScreen = ({
  trackId
}) => {
  const {
    mostRecentExamAttempt,
    mostRecentExamAttemptLoading,
    mostRecentExamAttemptError
  } = useMostRecentExamAttempt(Number(trackId));
  const {
    track,
    trackLoading,
    trackError
  } = useFullTrack(trackId);
  const {
    expiresOn,
    examExpiryLoading,
    examExpiryError
  } = useExamExpiry(Number(trackId));
  return /*#__PURE__*/_jsx(ExamFinishedScreenLayout, {
    callToAction: /*#__PURE__*/_jsx(RetakeExamButton, {
      trackId: trackId,
      use: "primary"
    }),
    error: mostRecentExamAttemptError || examExpiryError || trackError,
    heading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.exams.finished.examExpiredPracticalsIncomplete"
    }),
    illustration: "announcement",
    loading: mostRecentExamAttemptLoading || examExpiryLoading || trackLoading,
    prompt: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.exams.finished.yourPreviousScoreWas",
      options: {
        correctQuestionCount: mostRecentExamAttempt && mostRecentExamAttempt.score,
        totalQuestionCount: track && track.exam.length
      }
    }),
    subheading: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "learningCenter.exams.finished.examExpiredPracticalsIncompleteSubheading",
      options: {
        expiryDate: /*#__PURE__*/_jsx(FormattedDateTime, {
          format: "ll",
          value: expiresOn
        })
      }
    }),
    trackId: trackId
  });
};

export default ExamExpiredIncompleteExercisesScreen;